import Amplify, {Auth} from "aws-amplify";
import Actions from "./Actions";
import ServiceMerchant from "../../services/MerchantService";
import ServiceDp from "../../services/Services";

const merchantService = new ServiceMerchant();
const dpService = new ServiceDp();

Amplify.configure({
    API: {
        endpoints: [
            {
                name: "dev-directpayProcesses",
                endpoint: "https://kxyvih8zzh.execute-api.us-east-2.amazonaws.com/dev",
                custom_header: async () => {
                    return {Authorization: (await Auth.currentSession()).idToken.jwtToken};
                }
            }
        ]
    }
});

const getMerchantDetail = () => {
    return (dispatch) => {
        dispatch({type: Actions.MERCHANT_DETAIL_REQUEST});

        merchantService.getMerchantDetail((error, response) =>{
            if(error){
                console.debug(error);
                dispatch({
                    type: Actions.MERCHANT_DETAIL_FAIL,
                    message: "No merchant data found"
                });
            }else{
                dispatch({
                    type: Actions.MERCHANT_DETAIL_SUCCESS,
                    payload: response.data,
                });
            }
        });
    };
};

const generateApiKey = () => {
    return (dispatch) => {
        dispatch({type: Actions.MERCHANT_APIKEY_REQUEST});

        let email = localStorage.getItem("_email");
        merchantService.generateApiKey(email, (error,response) =>{
            if(error){
                console.debug(error);
                dispatch({
                    type: Actions.MERCHANT_APIKEY_FAIL,
                    message: "Unable to generate the API Key."
                });
            }else{
                if (response.data.message === "key_Exist") {
                    dispatch({
                        type: Actions.MERCHANT_APIKEY_EXIST,
                        payload: response.data.key,
                        message: "API Key already exists."
                    });
                }
                else {
                    dispatch({
                        type: Actions.MERCHANT_APIKEY_SUCCESS,
                        payload: response.data.key,
                        message: "API Key generated successfully."
                    });
                }
            }
        });
    };
};

const merchantKey = (userID, keyType) => {
    return (dispatch) => {

        if (keyType === "public_key") {
            dispatch({type: Actions.MERCHANT_PUB_KEY_REQUEST});
        } else {
            dispatch({type: Actions.MERCHANT_PRI_KEY_REQUEST});
        }
        
        merchantService.merchantKey(userID, keyType, (error, response) =>{
            if(error){
                console.debug(error);
                if (keyType === "public_key") {
                    dispatch({
                        type: Actions.MERCHANT_PUB_KEY_FAIL
                    });
                } else {
                    dispatch({
                        type: Actions.MERCHANT_PRI_KEY_FAIL
                    });
                }
            }else{
                if (response.status) {
                    if (response.status === 401) {
                        if (keyType === "public_key") {
                            dispatch({
                                type: Actions.MERCHANT_PUB_KEY_NOTFOUND
                            });
                        } else {
                            dispatch({
                                type: Actions.MERCHANT_PRI_KEY_NOTFOUND
                            });
                        }
                    } else {
                        if (keyType === "public_key") {
                            dispatch({
                                type: Actions.MERCHANT_PUB_KEY_FAIL
                            });
                        } else {
                            dispatch({
                                type: Actions.MERCHANT_PRI_KEY_FAIL
                            });
                        }
                    }
                } else {
                    if (keyType === "public_key") {
                        dispatch({
                            type: Actions.MERCHANT_PUB_KEY_SUCCESS,
                            payload: response
                        });
                    } else {
                        dispatch({
                            type: Actions.MERCHANT_PRI_KEY_SUCCESS,
                            payload: response
                        });
                    }
    
                }
            }
        });
    };
};

const generateMerchantKey = (userID) => {
    return (dispatch) => {
        dispatch({type: Actions.MERCHANT_KEY_GEN_REQUEST});

        merchantService.generateMerchantKey(userID, (err, response) =>{
            if(err){
                dispatch({
                    type: Actions.MERCHANT_KEY_GEN_FAIL
                });
            }else{
                if (response.status) {
                    if (response.status === 401) {
                        dispatch({
                            type: Actions.MERCHANT_PRI_KEY_NOTFOUND
                        });
                    } else {
                        dispatch({
                            type: Actions.MERCHANT_KEY_GEN_FAIL
                        });
                    }
                } else {
                    dispatch({
                        type: Actions.MERCHANT_PRI_KEY_SUCCESS,
                        payload: response
                    });
                }
            }
        });
    };
};

const setEndpoint = (url) => {
    return (dispatch) => {
        dispatch({type: Actions.MERCHANT_SET_ENDPOINT_REQUEST});

        merchantService.setEndpoint(url, (error, response) =>{
            if(error){
                console.debug(error);
                dispatch({type: Actions.MERCHANT_SET_ENDPOINT_FAIL});
            }else{
                if (response.status) {
                    if (response.status === 400) {
                        dispatch({type: Actions.MERCHANT_SET_ENDPOINT_FAIL});
                    }else{
                        dispatch({type: Actions.MERCHANT_SET_ENDPOINT_SUCCESS, payload: response.data});
                    }
                }
            }
        });
    };
};

const resetMerchantDetails = () => {
    return (dispatch) => {
        dispatch({type: Actions.MERCHANT_DETAIL_RESET});
    };
};

const getUserPicture = (userId) => {
    return (dispatch) => {
        dispatch({type:Actions.USER_PRO_IMG_REQUEST});
        dpService.getUploadFile({
            folderName: "ProfileImage",
            fileName: userId+".jpg",
            option: 1
        }, (err, res) =>{
            if (err){
                dispatch({type:Actions.USER_PRO_IMG_FAIL});
            }
            dispatch({
                type:Actions.USER_PRO_IMG_SUCCESS,
                payload: res
            });
        });
    };
};

const uploadUserPicture = (userId, picture) => {
    return (dispatch) => {
        dispatch({type:Actions.USER_PRO_IMG_REQUEST});
        dpService.fileUpload(userId, picture, (err, res) => {
            console.log("uploadUserPicture res",res);
            console.log("uploadUserPicture err",err);
            if (err) {
                console.log(err);
                dispatch({type:Actions.USER_PRO_IMG_FAIL});
            } else {
                console.log(res);
                dpService.getUploadFile({
                    folderName: "ProfileImage",
                    fileName: userId+".jpg",
                    option: 1
                }, (err, res) =>{
                    console.log("uploadUserPicture res",res);
                    console.log("uploadUserPicture err",err);
                    dispatch({
                        type:Actions.USER_PRO_IMG_SUCCESS,
                        payload: res
                    });
                });
            }
        });
    };
};

export {getMerchantDetail, generateApiKey, resetMerchantDetails, merchantKey, generateMerchantKey,
    setEndpoint, uploadUserPicture, getUserPicture};